import SuperMarioWord from './src/SuperMarioWorld';

//

SuperMarioWord.play();

document.querySelector('.Stage').addEventListener('click', ()=>{
});
